import type { PlaidEnvironment } from './_types';

const getPlaidTokenKey = (tenantId: string) => `${tenantId}_plaid_token`;

export function savePlaidTokenToLocalStorage(
  tenantId: string,
  token: string,
  environment: PlaidEnvironment
) {
  localStorage.setItem(getPlaidTokenKey(tenantId), `${environment}_${token}`);
}

export function getPlaidTokenFromLocalStorage(tenantId: string) {
  const stored = localStorage.getItem(getPlaidTokenKey(tenantId));

  if (!stored) {
    return null;
  }

  const [environment, token] = stored.split('_');

  return {
    environment: environment as PlaidEnvironment,
    token,
  };
}
